import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=0b595a0d&"
import script from "./RadioGroup.vue?vue&type=script&lang=js&"
export * from "./RadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b595a0d')) {
      api.createRecord('0b595a0d', component.options)
    } else {
      api.reload('0b595a0d', component.options)
    }
    module.hot.accept("./RadioGroup.vue?vue&type=template&id=0b595a0d&", function () {
      api.rerender('0b595a0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/RadioGroup.vue"
export default component.exports